import React from 'react';
import { Global, css } from '@emotion/react';

import {
  BookingForm,
  NewsPreview,
  ContactLocations,
  CallsToAction,
  Navigation,
  GoogleMap,
  Footer,
} from '@components';
import { globalStyles, MainContainer } from '@styles';

interface IStandardLayout extends React.PropsWithChildren {
  hasContactLocations?: boolean;
  hasCallsToAction?: boolean;
  hasGoogleMap?: boolean;
  hasNewsPreview?: boolean;
  hasBookingForm?: boolean;
}

const StandardLayout = ({
  hasContactLocations = true,
  hasCallsToAction = true,
  hasGoogleMap = true,
  hasNewsPreview = true,
  hasBookingForm = true,
  children,
}: IStandardLayout) => (
  <>
    <Global styles={globalStyles} />
    <Navigation />
    <MainContainer className="main">
      {children}
      {hasContactLocations && <ContactLocations />}
      {hasCallsToAction && (
        <CallsToAction
          useEmail
          cssOverrides={css`
            padding: 0 0 4rem;
          `}
        />
      )}
      {hasGoogleMap && <GoogleMap />}
      {hasNewsPreview && <NewsPreview />}
      {hasBookingForm && <BookingForm />}
      <Footer />
    </MainContainer>
  </>
);

export { StandardLayout };
export default StandardLayout;
